import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';


export default function WebFooter() {
  const navigate = useNavigate();

  return (
    <>

      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundImage: 'linear-gradient(to bottom, #29AAE1, #4D4D4D)' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={5}  >
                <h5 className='text-white'> Registrar Office</h5>

                <div className='d-flex'>
                  <span><FaLocationDot color='white' /></span>
                  <a
                    href='https://maps.app.goo.gl/tyj6nTuhQy1MUqV9A'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white ms-2 text-decoration-none'
                  >
                    :- B/3, A 302, Narmada Vihar Tarapur Road, opposite circle Office, Kurgaon, District Palghar, Maharashtra, India. 401502.
                  </a>
                </div>


                <h5 className='text-white mt-2'>Admin Office</h5>
                <div className='d-flex '>
                  <span><FaLocationDot color='white' /></span>
                  <a
                    href='https://maps.app.goo.gl/uKhmBZfiTeAa5rCb7'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white ms-2 text-decoration-none'
                  >

                    :- B/5, Next Moll, Near Parag Hospital, Plot No. P 20-21, Chitralaya, MIDC Tarapur, District Palghar, Maharashtra, India. 401504
                  </a>
                </div>

              </Col>

              <Col lg={4}>
                <h5 className='text-white'>Contact</h5>

                <div className='mb-2 '>
                  <a
                    href="https://wa.me/9561416140 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>

                      <FaMobileAlt color='white' />  +91 9561416140

                    </span>
                  </a>
                </div>

                <div className='d-flex '>
                  <a
                    href="mailto:siddhiinternational5557@gmail.com"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white' />  siddhiinternational5557@gmail.com
                    </span>
                  </a>
                </div>
              </Col>

              <Col lg={3}>
                <h5 className='text-white'>Connect With us</h5>
                <p className='text-white' >
                  We’re always looking to connect with those who share an interest
                  in a sustainable future.
                </p>

                <div className='d-flex '>

                  <a className='iconback' href='https://www.facebook.com/share/1Wtcc4PXR3/' target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={20} />
                  </a>
                  <a className=' iconback mx-1' href='https://www.linkedin.com/company/siddhinternational' target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={20} />
                  </a>
                  <a className='iconback' href='https://www.instagram.com/siddhinternational?igsh=MTZpY2t1djV0N3JjNw==' target="_blank" rel="noopener noreferrer">
                    <FaInstagramSquare size={20} />
                  </a>
                  <a className=' iconback mx-1' href='https://x.com/siddhinter2025' target="_blank" rel="noopener noreferrer">
                    <FaSquareXTwitter size={20} />
                  </a>
                </div>

              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} SIDDHI INTERNATIONAL |
                <a href="https://bizkranti.com/" style={{ color: 'white', textDecoration: 'none' }}>Design By : Bizkranti It Innovations Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>


    </>
  )
}
